import * as Constants from 'client/util/Constants';
import { get, isEmpty } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { notify } from 'client/util';
import DownloadUtil from 'client/util/DownloadUtil';

const { ItemTypeConsts, StoreModelMap, StoreModuleMap } = Constants;
const { error } = Constants.default;

const mdmSettingsModel = StoreModelMap[ItemTypeConsts.mdmSettings];
const systemModel = StoreModelMap[ItemTypeConsts.system];
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  DownloadUtil,

  data: () => ({
    downloadUrl: '',
    enrollmentProfiles: [],
  }),

  computed: {
    ...mapGetters(mdmSettingsModel, [
      'getDmId',
      'isApnsPushTopicEmpty',
    ]),

    ...mapGetters(systemModel, [
      'isMacOS',
      'isSystemMdmEnrolled',
      'isSystemMdmVendorValid',
      'isSystemDepEnrolled',
      'isSystemEnrolledWithDifferentVendor',
      'isUserApproved',
      'getMdmDevices',
      'getSystemMdmId',
      'getSystemMdmProfileIdentifier',
      'isOrgMdmEnrolled',
    ]),

    ...mapState(settingsModule, ['isCustomer', 'features']),

    enrollmentProfileId() {
      if (isEmpty(this.enrollmentProfiles)) return '';

      return this.enrollmentProfiles[0].id;
    },

    isCustomerDirectoryInsightsEnabled() {
      return this.isCustomer && this.isDirectoryInsightsEnabled;
    },

    isDirectoryInsightsEnabled() {
      return get(this.features, 'directoryInsightsPremium.enabled', false);
    },

    isFreeUserSystemAndOrgEnrolled() {
      return !this.isCustomer && this.isOrgEnrolledAndSystemEnrolled;
    },

    isOrgEnrolledAndSystemEnrolled() {
      return this.isOrgMdmEnrolled && this.isSystemMdmEnrolled;
    },

    isOrgEnrolledAndSystemNotEnrolled() {
      return this.isOrgMdmEnrolled && !this.isSystemMdmEnrolled;
    },

    isOrgEnrolledAndSystemIsDepEnrolledWithDifferentVendor() {
      return this.isOrgMdmEnrolled && this.isSystemEnrolledWithDifferentVendor;
    },
  },

  methods: {
    ...mapActions(mdmSettingsModel, {
      fetchMdmSettings: 'fetchMdmSettings',
      getEnrollmentProfiles: 'enrollmentProfiles',
      getMobileConfig: 'getMobileConfig',
      fetchEnrollmentProfileDownloadUrl: 'fetchEnrollmentProfileDownloadUrl',
    }),

    ...mapActions(systemModel, ['createMdmSettings']),

    setEnrollmentProfiles() {
      this.getEnrollmentProfiles()
        .then((resp) => { this.enrollmentProfiles = resp; });
    },

    async handleDownloadProfile() {
      try {
        const resp = await this.getMobileConfig({ enrollmentProfileId: this.enrollmentProfileId });
        this.$options.DownloadUtil.downloadFile(resp.data, 'profile_jc.mobileconfig');
      } catch (e) {
        notify(error, `Unable to download profile: ${e.toString()}`);
      }
    },

    async retrieveEnrollmentProfileDownloadUrl() {
      try {
        const response = await this.fetchEnrollmentProfileDownloadUrl();
        this.downloadUrl = response.download_url;
      } catch {
        notify(error, 'The service encountered a temporary error and could not retrieve the enrollment profile download URL. Please try again later.');
      }
    },
  },
};
